"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZrxSwapper = void 0;
const types_1 = require("@shapeshiftoss/types");
const api_1 = require("../../api");
const getZrxTradeQuote_1 = require("./getZrxTradeQuote/getZrxTradeQuote");
const blacklist_1 = require("./utils/blacklist");
const helpers_1 = require("./utils/helpers/helpers");
const zrxApprovalNeeded_1 = require("./zrxApprovalNeeded/zrxApprovalNeeded");
const zrxApprove_1 = require("./zrxApprove/zrxApprove");
const zrxBuildTrade_1 = require("./zrxBuildTrade/zrxBuildTrade");
const zrxExecuteTrade_1 = require("./zrxExecuteTrade/zrxExecuteTrade");
class ZrxSwapper {
    constructor(deps) {
        this.name = api_1.SwapperName.Zrx;
        this.deps = deps;
        this.chainId = deps.adapter.getChainId();
    }
    getType() {
        switch (this.chainId) {
            case types_1.KnownChainIds.EthereumMainnet:
                return api_1.SwapperType.ZrxEthereum;
            case types_1.KnownChainIds.AvalancheMainnet:
                return api_1.SwapperType.ZrxAvalanche;
            default:
                throw new api_1.SwapError('[getType]', {
                    code: api_1.SwapErrorTypes.UNSUPPORTED_CHAIN,
                });
        }
    }
    async buildTrade(args) {
        return (0, zrxBuildTrade_1.zrxBuildTrade)(this.deps, args);
    }
    async getTradeQuote(input) {
        return (0, getZrxTradeQuote_1.getZrxTradeQuote)(input);
    }
    async getUsdRate(input) {
        return (0, helpers_1.getUsdRate)(input);
    }
    async executeTrade(args) {
        return (0, zrxExecuteTrade_1.zrxExecuteTrade)(this.deps, args);
    }
    async approvalNeeded(args) {
        return (0, zrxApprovalNeeded_1.zrxApprovalNeeded)(this.deps, args);
    }
    async approveInfinite(args) {
        return (0, zrxApprove_1.zrxApproveInfinite)(this.deps, args);
    }
    async approveAmount(args) {
        return (0, zrxApprove_1.zrxApproveAmount)(this.deps, args);
    }
    filterBuyAssetsBySellAssetId(args) {
        const { assetIds = [], sellAssetId } = args;
        return assetIds.filter((id) => id.startsWith(this.chainId) &&
            (sellAssetId === null || sellAssetId === void 0 ? void 0 : sellAssetId.startsWith(this.chainId)) &&
            !blacklist_1.UNSUPPORTED_ASSETS.includes(id));
    }
    filterAssetIdsBySellable(assetIds = []) {
        return assetIds.filter((id) => id.startsWith(this.chainId) && !blacklist_1.UNSUPPORTED_ASSETS.includes(id));
    }
    async getTradeTxs(tradeResult) {
        return {
            sellTxid: tradeResult.tradeId,
            buyTxid: tradeResult.tradeId,
        };
    }
}
exports.ZrxSwapper = ZrxSwapper;
